import './_article-external-sources.scss';

export default () => {};
